import React, { Component } from 'react';

import StackupFreeCardItem from './StackupFreeCardItem';

import AdvertisementService from '../../services/AdvertisementService';

export default class StackupFreeViewCentral extends Component {

    constructor(props) {
        super(props);

        this.adService = new AdvertisementService();

        this.state = {
            contentId: -1,
            adImage: "",
            adLink: "",
        }

        this.viewOuter = null;

        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.generateStackItems = this.generateStackItems.bind(this);

        let self = this;
        self.adService.getContent((content) => {
            self.setState({ contentId: content.contentId, adImage: content.imageUrl, adLink: content.linkUrl });
            self.advertisementInterval = setInterval(() => {

                if (!window.zzIsPaused/* && this.props.isPhone*/) {
                    self.adService.getContent((content) => {
                        self.setState({ contentId: content.contentId, adImage: content.imageUrl, adLink: content.linkUrl });
                    });
                }
            }, 30000);
        });
    }


    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleScrollTop(event) {
        $(".stackup-central-outer")[0].scrollTo(0, 0);
    }

    handleScroll(e) {
        var self = this;

        this.props.handleScrollTop(e.target.scrollTop <= 0, e.target.scrollTop);
    }

    generateStackItems() {

        let stackItems = [];

        let period = this.props.screenContext.range === 'CUR' ? 'CYNOW' : 'CY' + this.props.screenContext.range;

        let dataSet = _.sortBy(this.props.stackData, 'name');

        for (var i = 0; i < dataSet.length; i++) {
            let key = dataSet[i].name + '|' + period;
            let identity = dataSet[i];

            let tmpData = {};
            switch (this.props.screenContext.range) {
                case "CUR":
                    tmpData = identity.data.nowMod;
                    break;
                case "WTD":
                    tmpData = identity.data.wkMod;
                    break;
                case "MTD":
                    tmpData = identity.data.mthMod;
                    break;
                case "QTD":
                    tmpData = identity.data.qtrMod;
                    break;
                case "YTD":
                    tmpData = identity.data.yrMod;
                    break;
            }

            stackItems.push((
                <StackupFreeCardItem
                    key={key}
                    identity={identity}
                    data={tmpData}
                    masterKpiList={this.props.screenContext.masterKpiList}
                />
            ));
        }

        return stackItems;
    }

    render() {

        if (this.props.stackData === undefined || this.props.stackData.length === 0 || this.props.screenContext === undefined) {
            return (
                <div className="stackup-central-outer" ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScroll}>
                    <div className="error-message-outer">
                        <div className="error-image-container">
                            <div className="error-image material-icons">layers</div>
                        </div>
                        <div className="error-message-container">
                            <div className="error-message">{"Stack-Up Data for Selected " + (this.props.tagFilter.tags.length === 0 ? "Date" : "Tags") + " Not Found"}</div>
                        </div>
                    </div>
                </div>
            );
        }

        let titleText = "";
        switch (this.props.screenContext.range) {
            case 'CUR': titleText += 'On This Day';
                break;
            case 'WTD': titleText += 'Week to Date';
                break;
            case 'MTD': titleText += 'Month to Date';
                break;
            case 'QTD': titleText += 'Quarter to Date';
                break;
            case 'YTD': titleText += 'Year to Date';
                break;
        }

        let regTitleText = "Metrics (" + titleText + ")";

        let stackItems = this.generateStackItems();

        return (
            <div className="stackup-central-outer" ref={(outer) => { this.viewOuter = outer }} style={this.props.style} onScroll={this.handleScroll}>
                <div className="stackup-central-regular-card-container">
                    <div className="stackup-central-title-container">
                        <div className="stackup-central-title">{regTitleText}</div>
                    </div>
                    {stackItems}
                </div>
                <div className="advertisement-card-container">
                    <img onClick={this.openAdLink} className="advertisement-card" src={this.state.adImage} />
                </div>
                <div className="spacer-short"></div>
            </div>
        );
    }
}